export default {
    info: 'información',
    warning: 'aviso',
    dismiss: 'Despedir',
};
